import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { CMSProvider, useCMS } from "./context/CMSContext";
import { AuthProvider } from "./context/AuthContext";
import PromoBar from "./components/PromoBar";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Reviews from "./components/Reviews";
import WallOfLove from "./components/WallOfLove";
import Pricing from "./components/Pricing";
import ClubCTA from "./components/ClubCTA";
import Features from "./components/Features";
import Compare from "./components/Compare";
import SwitchCTA from "./components/SwitchCTA";
import Migration from "./components/Migration";
import FAQ from "./components/FAQ";
import Footer from "./components/Footer";
import Popup from "./components/Popup";
import LoginPage from "./pages/LoginPage";
import AuthCallback from "./pages/AuthCallback";
import AdminPage from "./pages/AdminPage";
import CheckoutPage from "./pages/CheckoutPage";
import PortalPage from "./pages/PortalPage";
import PagePage from "./pages/PagePage";
import SetPasswordPage from "./pages/SetPasswordPage";
import TryLandingPage from "./pages/TryLandingPage";
import SEOHead from "./components/SEOHead";
import TawkChat from "./components/TawkChat";
import { Toaster } from "./components/ui/toaster";
import Logo from "./components/Logo";

function Home() {
  const { loading } = useCMS();
  const location = useLocation();

  useEffect(() => {
    if (loading) return;
    if (location.hash) {
      const id = location.hash.replace("#", "");
      // wait for sections to mount
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 120);
    }
  }, [loading, location.hash]);

  if (loading) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-[#FFFBF6]">
        <Logo size={48} />
        <p className="mt-4 text-[#11151C]/60 text-sm">Loading...</p>
      </div>
    );
  }
  return (
    <div className="lm-font min-h-screen bg-white text-[#11151C]">
      <PromoBar />
      <Navbar />
      <Hero />
      <Reviews />
      <WallOfLove />
      <Pricing />
      <ClubCTA />
      <Features />
      <Compare />
      <SwitchCTA />
      <Migration />
      <FAQ />
      <Footer />
      <Popup />
      <Toaster />
    </div>
  );
}

function App() {
  // Subdomain routing: try.livemover.com serves the TryLandingPage at "/"
  const isTrySubdomain =
    typeof window !== "undefined" && /^try\./i.test(window.location.hostname);

  return (
    <BrowserRouter>
      <CMSProvider>
        <AuthProvider>
          <SEOHead />
          <Routes>
            <Route path="/" element={isTrySubdomain ? <TryLandingPage /> : <Home />} />
            <Route path="/try" element={<TryLandingPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/checkout" element={<CheckoutPage />} />
            <Route path="/portal" element={<PortalPage />} />
            <Route path="/set-password" element={<SetPasswordPage />} />
            <Route path="/:slug" element={<PagePage />} />
          </Routes>
          <TawkChat />
        </AuthProvider>
      </CMSProvider>
    </BrowserRouter>
  );
}

export default App;
